import { createReducer, on } from '@ngrx/store';
import { STATE } from '@ptg-shared/constance';

import * as MunicipalityPaymentAction from '../actions/municipality-payment.action';
import { EditMetRequirementResponse, MunicipalityList } from '../../types/models';

export const MunicipalityPaymentFeatureKey = 'municipalityPayment';
export interface State {
  isLoading: boolean;
  payments: MunicipalityList;
  createState?: string;
  updateState?: string;
  editMetRequirementState?: string;
  editMetRequirementResponse?: EditMetRequirementResponse
}

const initialState: State = {
  isLoading: true,
  payments: {
    total: 0,
    payments: [],
    totalService: '',
  },
  createState: '',
  updateState: '',
  editMetRequirementState: '',
};

export const reducer = createReducer(
  initialState,
  on(MunicipalityPaymentAction.getMunicipalityPaymentList, (state, {}) => ({
    ...state,
    isLoading: true,
    payments: {
      total: 0,
      payments: [],
      totalService: '',
    },
  })),
  on(
    MunicipalityPaymentAction.municipalityPaymentListSuccess,
    (state, { payments }) => ({
      ...state,
      isLoading: false,
      payments,
    })
  ),
  on(MunicipalityPaymentAction.municipalityPaymentListFailure, (state) => ({
    ...state,
    isLoading: false,
    payments: {
      total: 0,
      payments: [],
      totalService: '',
    },
  })),

  on(MunicipalityPaymentAction.clearMunicipalityPaymentState, (state) => ({
    ...state,
    createState: '',
    updateState: '',
    editMetRequirementState: '',
    editMetRequirementResponse: undefined,
  })),

  on(MunicipalityPaymentAction.editMunicipalityPaymentMetRequirement, (state) => ({
    ...state,
    editMetRequirementState: ''
  })),
  on(MunicipalityPaymentAction.editMunicipalityPaymentMetRequirementSuccess, (state, { editMetRequirementResponse }) => ({
    ...state,
    editMetRequirementState: STATE.SUCCESS,
    editMetRequirementResponse,
  })),
  on(MunicipalityPaymentAction.editMunicipalityPaymentMetRequirementFailure, (state) => ({
    ...state,
    editMetRequirementState: STATE.FAIL
  })),
);
